import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppServiceService } from 'src/app/api/app-service.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  @Output() onRegistrationSuccess: EventEmitter<any> = new EventEmitter();
  @Output() onNavigatePages: EventEmitter<any> = new EventEmitter();

  /**
   *Registraion page variables
   */
  public showPassword = false;
  public showrepeatPassword = false;
  public value: any = {
    first_name: "",
    last_name: "",
    mobile_number: "",
    email: "",
    password: "",
    confirm_password: "",
    tac: false,
    newsalert: false,
  }

  isRegisterInProgress: boolean = false;
  
  public lang: any = null;

  constructor(public appService: AppServiceService, private router: Router, public translate:TranslateService) {

  }

  ngOnInit() {
    this.getLang();
  }

  async register() {

    this.value['type'] = 'registered';
    this.value['newsalert'] = this.value['newsalert'] ? "true" : "false";

    this.isRegisterInProgress = true;
    await this.appService.register_from_email(this.value, true);
    this.isRegisterInProgress = false;
    if (this.appService.appObject.errors && Object.keys(this.appService.appObject.errors).length) {
      let first = '';
      for (var key in this.appService.appObject.errors) {
        if (first == '') {
          first = key;
        }
      }

      switch (first) {
        case 'first_name':
          document.getElementById("first-name").focus();
          break;
        case 'last_name':
          document.getElementById("last-name").focus();
          break;
        case 'mobile_number':
          document.getElementById("telephone").focus();
          break;
        case 'email':
          document.getElementById("email").focus();
          break;
        case 'password':
          document.getElementById("password").focus();
          break;
        case 'confirm_password':
          document.getElementById("passwordrepeat").focus();
          break;

      }

    } else if(this.appService.registrationServerError) {
      this.appService.showToast('Something went wrong', 'danger');
    } else {
      if (this.appService.isWebVersion) {
        // if registration was success then call callback function
        this.onRegistrationSuccess.emit();
      } else {
        this.appService.navigateToRegisterd();
      }
    }

  }

  togglePassword(input) {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  emailvalidation() {
    if (this.value.email) {
      this.value.email = this.value.email.trim();
    }
  }

  /**
   * This will redirect user to given route
   * @param location string value of route path
   */
  async navigateTo(slug) {
    if (!this.appService.isWebVersion)
      this.router.navigate([slug === 'tnc' ? '/pages/tnc' : '/pages/pnp'])
    else {
      this.onNavigatePages.emit([slug]);
    }
  }

  ionViewDidEnter() {
    if (this.appService.appObject.isAuthed) {
      if (this.appService.isWebVersion)
        this.router.navigate(['home']);
      else
        this.router.navigate(['home']);
    }
  }

  /**
   * 
   * get languages
   */
   async getLang(){
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }

}
